export default "__VITE_ASSET__DjBACRP1__"